import EventActionProto from '../event-action-proto';
import NoteTypeCollection from "../../gd-model/note-type/note-type-collection";
import TodoListTemplateCollection from "../../gd-model/todo-list/todo-list-template-collection";

class TodoListTemplatesResetByCompany extends EventActionProto {

    constructor(uid, data) {
        super(uid, data, false);
        this.restartApps = ['organization-settings-todo-list-templates','organization-settings-todo-list-template'];
    }

    process() {
        if (!gd.session._todoListTemplates) {
            console.error("ouups... that's strange #8di20 - how come ????")
            gd.session._todoListTemplates = new TodoListTemplateCollection(this.data, {parse:true});
            return
        }

        gd.session._todoListTemplates.resetByCompany(this.data.companyId, this.data.data);
        super.process();
    }
}

module.exports = TodoListTemplatesResetByCompany;


